import { ClaimType } from '@constants';
import { useSelector } from 'react-redux';
import { CheckPage } from '../check';
import { Delay } from '../delay';

const ChoosePageMap = {
  [ClaimType.Delay]: <Delay />,
  [ClaimType.Damage]: <CheckPage />,
  [ClaimType.Loss]: <CheckPage />,
};

export const ChoosePage = () => {
  const {
    type,
  } = useSelector((state) => state.claim);

  return ChoosePageMap[type];
};
